import React from "react";
import { useRoutes } from "react-router-dom";
import { withRouter } from "../../util/with-router";
import { TransitionGroup } from "react-transition-group";
import ViewInvoices from "./invoices/invoices-list";
import CreateInvoice from './invoices/create-invoice';
import RetentionList from './retention'
import RBACApplicationAuth from "../../layout/rbac";
import * as paths from "../../constants/route-paths";

function CustomRoutes({ location }) {
    let element = useRoutes([
        {
            path: paths.INVOICES,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={ViewInvoices} />,
        },
        {
            path: paths.CREATE_INVOICE,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={CreateInvoice} />,
        },
        {
            path: paths.RETENTION,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={RetentionList} />,
        },
    ]);

    return element;
}

class Root extends React.PureComponent {
    render() {
        const { location } = this.props;
        return (
            <div className="clearfix" style={{ width: "100%" }}>
                <TransitionGroup>
                    <CustomRoutes location={location} />
                </TransitionGroup>
            </div>
        );
    }
}
export default withRouter(Root);
